import { pathOr } from 'ramda'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { isFunction } from 'utils'
import { normalizeLanguage } from 'utils/i18n'

const useLanguageSwitcher = () => {
  const { i18n } = useTranslation()

  const locale = useSelector(state => (
    pathOr('en', ['embed', 'configuration', 'locale'], state)
  ))

  useEffect(() => {
    // @ts-ignore
    if (!i18n || !isFunction(i18n.changeLanguage)) {
      return
    }

    // @ts-ignore
    i18n.changeLanguage(normalizeLanguage(locale))
  }, [i18n, locale])
}

export default useLanguageSwitcher
